import {Divider, Box} from "@mui/material";

export default function DividerP(){
    return <Box>
        <Divider sx={{marginTop:5,marginBottom:5 ,color:"purple"}} data-aos="zoom-in" data-aos-delay="200"/>
    </Box>
}